function getImageAlignment(a, b, c, d, e, f, g) {
  var h = {};
  return 'top' === b ? h.y = a : 'bottom' === b ? h.y = g - e - a : 'middle' === b ? h.y = (g - e) / 2 : void 0, 'left' === c ? h.x = a : 'right' === c ? h.x = f - d - a : 'middle' === c ? h.x = (f - d) / 2 : void 0, h;
}

function getAlignImage(a, b, c, d, e, f, g, h, i, j) {
  var k,
      l,
      m,
      n,
      o,
      p,
      q = Math.ceil,
      r = {};
  return 'center' === c ? (r.width = d, r.height = e, r.y = g / 2 - e / 2, r.x = f / 2 - d / 2) : 'stretch' === c ? (r.width = f - 2 * h, r.height = g - 2 * h, r.y = h, r.x = h) : 'tile' === c ? (r.width = d, r.height = e, r.tileInfo = {}, r.tileInfo.xCount = n = q(i / d), r.tileInfo.yCount = o = q(j / e), p = getImageAlignment(h, a, b, d * n, e * o, f, g), r.y = p.y, r.x = p.x) : 'fit' === c ? (k = d / e, l = i / j, m = k > l ? i / d : j / e, r.width = d * m, r.height = e * m, p = getImageAlignment(h, a, b, r.width, r.height, f, g), r.y = p.y, r.x = p.x) : 'fill' === c ? (k = d / e, l = i / j, m = k > l ? j / e : i / d, r.width = d * m, r.height = e * m, p = getImageAlignment(h, a, b, r.width, r.height, f, g), r.y = p.y, r.x = p.x) : (p = getImageAlignment(h, a, b, d, e, f, g), r.width = d, r.height = e, r.y = p.y, r.x = p.x), r;
}

export { getAlignImage };